;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.services')
    .service('ChorusService', ChorusService)

  ChorusService.$inject = [
    // Angular
    '$http',
    // Libs
    // Managers
    // Services
    // Const
    'urls'
    // Resolved
  ]

  function ChorusService (// Angular
    $http,
    // Libs
    // Managers
    // Services
    // Const
    urls
    // Resolved
  ) {
    const self = this

    _.extend(self, {
      // Public Attributes
      // Public Method
      checkIntegration,
      deposerFlux,
      rattacherHistorique,
      rattacherHistoriqueBulk
    })

    function checkIntegration (id, isCreditNote) {
      return $http({
        url: `${urls.backendChorus}/chorus/${isCreditNote ? 'creditNotes' : 'invoices'}/checkIntegration`,
        method: 'POST',
        data: {
          lastMonitoringId: id
        },
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function deposerFlux (id, isCreditNote) {
      const url = `${urls.backendChorus}/chorus/${isCreditNote ? 'creditNotes' : 'invoices'}/deposer/flux`
      return $http({
        url: url,
        method: 'POST',
        data: {
          _id: id,
          sync: false
        },
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function rattacherHistorique (chorusId, elementId, isCreditNote) {
      const url = `${urls.backendChorus}/chorus/rattacher/historique`
      return $http({
        url: url,
        method: 'POST',
        data: [{
          idFacture: chorusId,
          invoiceId: isCreditNote ? null : elementId,
          creditNoteId: isCreditNote ? elementId : null
        }],
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function rattacherHistoriqueBulk (payload) {
      const url = `${urls.backendChorus}/chorus/rattacher/historique`
      return $http({
        url: url,
        method: 'POST',
        data: payload,
        headers: { 'Content-Type': 'application/json' }
      })
    }
  }
})(window.angular, window._)
